
interface NavigationProps {
  scrolled: boolean;
}

export default function Navigation({ scrolled }: NavigationProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-20 py-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img 
            src="https://public.readdy.ai/ai/img_res/1e40b28d-4eaf-43eb-b7a-5b4121cbbda3.png" 
            alt="BOMAG Logo" 
            className="w-10 h-10 object-contain"
          />
          <span className={`text-lg font-semibold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>
            BOMAG d.o.o.
          </span>
        </div>
        
        <div className="flex items-center gap-8">
          {['home', 'about', 'products', 'features', 'contact'].map((item) => (
            <button
              key={item}
              onClick={() => scrollToSection(item)}
              className={`text-sm font-medium capitalize transition-colors cursor-pointer whitespace-nowrap ${
                scrolled 
                  ? 'text-gray-700 hover:text-teal-600' 
                  : 'text-white hover:text-teal-300'
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}